export class AssignedProducer {
  public name: string;
  public producerIdNum: string;
}
